export default "__VITE_ASSET__4206a74b__"